import React, { Component } from 'react';
import './Tabs.css';


class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

        let tabs = this.props.tabs.map((item,key) => {
            return (
                <li className="nav-item" key={`${item.groupId+`id`+item.segmentId}`} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" :"nav-link"} href={`#${item.groupId+`id`+item.segmentId}`} aria-controls={`${item.groupId+`id`+item.segmentId}`} aria-selected="true">{item.groupName+` - `+item.segmentName}</a>
            </li>)
        });

        let tabsContent = this.props.tabs.map((tabItem, key) => {

            const groupId = this.props.tabs.find(r => r.groupId === tabItem.groupId).groupId;
            const segmentId = this.props.tabs.find(r => r.segmentId === tabItem.segmentId).segmentId;

            let data = this.props.positioningData.find(r => r.segmentId === segmentId &&  r.groupId === groupId)

            return (
                <div id={groupId+`id`+segmentId} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv positioning-tab-content": "tab-pane fade tabContentdiv compete-tab-content positioning-tab-content"} role="tabpanel" key={key}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='form-group'>
                                <strong>For Whom</strong>: <span>{data.forWhome}</span>
                            </div>
                            <div className='form-group'>
                                <strong>Brand/Company Name</strong>: <span>{data.brand}</span>
                            </div>
                            <div className='form-group'>
                                <strong>Is the</strong>: <span>{data.isThe}</span>
                            </div>
                            <div className='form-group'>
                                <strong>That</strong>: <span>{data.that}</span>
                            </div>
                            <div className='form-group'>
                                <strong>Because</strong>: <span>{data.because}</span>
                            </div>
                            <div className='form-group'>
                                <strong>So That</strong>: <span>{data.soThat}</span>
                            </div>
                        </div>
                        <div className="col-md-6 positioning-statement">
                            <h4>Positioning Statement:</h4>
                            <textarea value={data ? data.statement : ''} className='form-control' onChange={(e)=>this.props.onChangeValu(e, 'statement', data, groupId, segmentId)}></textarea>
                        </div>
                    </div>

                </div>
            )

        })

        return (
            <div className='criteria-tabs-content attractiveness-tab-content'>
                <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                    {tabs}
                </ul>
                <div className="tab-content benefitsTabcontent" id="myTabContent" >
                    {tabsContent}
                </div>
            </div>
        )
    }
}

export default (Tabs);



// WEBPACK FOOTER //
// ./src/components/PositioningStatement/Step2/Tabs/Tabs.jsx